import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';

@Component({
	standalone: false,

	selector: 'onboarding-spotlight-point, [onboardingSpotlightPoint]',
	templateUrl: './spotlight-point.component.html',
	styleUrls: ['./spotlight-point.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingSpotlightPointComponent {}

@NgModule({
	declarations: [OnboardingSpotlightPointComponent],
	exports: [OnboardingSpotlightPointComponent],
})
export class OnboardingSpotlightPointComponentModule {}
